<div class="flex flex--col" [ngStyle]="getDropdownStyles()" (mouseup)="detectChanges()">
  <ng-container *ngIf="showSortSection && showFilterSection">
    <div class="flex flex--row flex--middle u-pb--">
      <!-- ico-sort-16.svg -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        class="svg-icon eds-icon-color"
      >
        <g>
          <path
            d="M12.5,5.75a.47.47,0,0,1-.35-.15L8,1.46,3.85,5.6a.49.49,0,0,1-.7-.7L7.65.4a.48.48,0,0,1,.7,0l4.5,4.5a.48.48,0,0,1,0,.7A.47.47,0,0,1,12.5,5.75ZM8.35,15.6l4.5-4.5a.49.49,0,0,0-.7-.7L8,14.54,3.85,10.4a.49.49,0,0,0-.7.7l4.5,4.5a.48.48,0,0,0,.7,0Z"
          />
        </g>
      </svg>
      <span class="text-16 u-ml-- no-select">{{ 'vg.sort' | translate }}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="showSortSection">
    <ng-container *ngIf="sortTemplate | isTemplateRef">
      <ng-container *ngTemplateOutlet="sortTemplate; context: { column: column }"> </ng-container>
    </ng-container>
    <ng-container *ngIf="!(sortTemplate | isTemplateRef)">
      <div [innerHTML]="sortTemplate | generateTemplate: { column: column } | safeHtml"></div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showSortSection && showFilterSection">
    <div class="menu__item-divider" style="margin-top: 1.4rem; margin-bottom: 1.4rem"></div>
  </ng-container>
  <ng-container *ngIf="showSortSection && showFilterSection">
    <div class="flex flex--row flex--middle u-pb--">
      <!-- ico-filter-16.svg -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        class="svg-icon eds-icon-color"
      >
        <g>
          <path
            d="M14.9.9l-4.65,7A1.55,1.55,0,0,0,10,8.7v6.8a.5.5,0,0,1-.72.45l-3-1.5A.51.51,0,0,1,6,14V8.71a1.56,1.56,0,0,0-.25-.84L1.1.9A.58.58,0,0,1,1.58,0H14.42A.58.58,0,0,1,14.9.9Z"
          />
        </g>
      </svg>
      <span class="text-16 u-ml-- no-select">{{ 'vg.filter' | translate }}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="showFilterSection">
    <ng-container *ngIf="filterTemplate | isTemplateRef">
      <ng-container *ngTemplateOutlet="filterTemplate; context: filterContext"> </ng-container>
    </ng-container>
    <ng-container *ngIf="!(filterTemplate | isTemplateRef)">
      <div [innerHTML]="filterTemplate | generateTemplate: filterContext.$implicit | safeHtml"></div>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showFilterSection && !cardFilterChild">
    <div class="flex flex--row flex--stretch flex--justify u-mt--">
      <button
        class="button button--tertiary button-clear"
        (click)="onClear()"
        [disabled]="!(filterController && filterController.canClear())"
      >
        <span class="u-ph---">
          {{ 'vg.clear' | translate }}
        </span>
      </button>
      <button
        class="button button--primary button-apply"
        (click)="onApply()"
        [disabled]="!(filterController && filterController.canApply())"
      >
        <span class="u-ph---">
          {{ 'vg.done' | translate }}
        </span>
      </button>
    </div>
  </ng-container>
</div>

<!-- Sort template -->
<ng-template #defaultSortTemplate>
  <div>
    <div class="radio-wrapper">
      <label [for]="column.columnId + '-sort-ascending'" class="radio">
        <input
          [id]="column.columnId + '-sort-ascending'"
          type="radio"
          name="sort_radio_group"
          class="radio__input"
          [checked]="sortedAscending === true"
          (click)="onItemSortClicked(column, true)"
        />
        <span class="radio__label">{{ 'vg.sortAscending' | translate }}</span>
      </label>
    </div>
    <div class="radio-wrapper">
      <label [for]="column.columnId + '-sort-descending'" class="radio">
        <input
          [id]="column.columnId + '-sort-descending'"
          type="radio"
          name="sort_radio_group"
          class="radio__input"
          [checked]="sortedAscending === false"
          (click)="onItemSortClicked(column, false)"
        />
        <span class="radio__label">{{ 'vg.sortDescending' | translate }}</span>
      </label>
    </div>
  </div>
</ng-template>

<!-- TextFilter template -->
<ng-template #textFilter let-context let-params="$implicit.params">
  <div class="flex flex--nowrap flex--row flex--middle p-rel" [attr.aria-invalid]="context.errors.value">
    <input
      class="textbox u-p--- input-with-icon {{column.headerStyleClasses}}"
      [attr.aria-invalid]="context.errors.value"
      type="text"
      [id]="context.columnId + '-search-input'"
      [attr.maxLength]="params.maxLength"
      [placeholder]="params.searchHint || ('vg.searchX' | translate: { value: (column.headerLabel | translate) })"
      [(ngModel)]="context.data.value"
      (ngModelChange)="context.onModelChange()"
      [tooltip]="params.searchHint || ('vg.searchX' | translate: { value: (column.headerLabel | translate) })"
      [overflowOnly]="true"
    />
    <div class="filter__icon filter__icon--no-event" *ngIf="!context.data.value">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        class="svg-icon eds-icon-color"
      >
        <g>
          <path
            d="M0,6a6,6,0,0,0,9.47,4.89l4.82,4.82a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L10.89,9.47A6,6,0,1,0,0,6ZM1,6a5,5,0,1,1,5,5A5,5,0,0,1,1,6Z"
          />
        </g>
      </svg>
    </div>
    <div class="filter__icon" *ngIf="context.data.value" (click)="context.removeSearch()">
      <!-- ico-close-12.svg -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        class="svg-icon eds-icon-color"
      >
        <g>
          <path
            d="M11.85,11.15a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0L6,6.71.85,11.85A.47.47,0,0,1,.5,12a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L5.29,6,.15.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0L6,5.29,11.15.15a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7L6.71,6Z"
          />
        </g>
      </svg>
    </div>
  </div>
  <ng-container *ngIf="context.errors.value">
    <div role="alert" class="form__error-text">
      <div class="flex flex--row flex--middle">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" class="svg-icon icon">
          <g>
            <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z" fill="currentColor" />
            <path
              d="M9,13H7V11H9ZM9,8A.94.94,0,0,1,8,9,.94.94,0,0,1,7,8V4A.94.94,0,0,1,8,3,.94.94,0,0,1,9,4Z"
              fill="#fff"
            />
          </g>
        </svg>
        <span class="u-ml----">
          <ng-container *ngIf="context.errors.message">
            {{ context.errors.message | translate }}
          </ng-container>
          <ng-container *ngIf="!context.errors.message">
            {{ 'vg.invalidEntry' | translate }}
          </ng-container>
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="params.recents && params.recents.length > 0">
    <div class="scrollable u-mt--" wfmScrollbar>
      <ng-container *ngFor="let recent of params.recents">
        <div class="flex flex--row flex--middle recent-item p-rel u-ph---">
          <button
            type="button"
            aria-pressed="false"
            class="button--no-border button button--tertiary recent-text"
            (click)="context.data.value = recent; context.onModelChange()"
          >
            <span class="text-ellipsis">{{ recent }}</span>
          </button>
          <div class="flex flex-middle remove-recent" (click)="context.removeRecent(recent)">
            <!-- ico-remove-16.svg -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              class="svg-icon eds-icon-color"
            >
              <g>
                <path
                  d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.85,10.44a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0L8,9.41,5.56,11.85a.5.5,0,0,1-.71,0l-.7-.7a.5.5,0,0,1,0-.71L6.59,8,4.15,5.56a.5.5,0,0,1,0-.71l.7-.7a.5.5,0,0,1,.71,0L8,6.59l2.44-2.44a.5.5,0,0,1,.71,0l.7.7a.5.5,0,0,1,0,.71L9.41,8Z"
                />
              </g>
            </svg>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- DateFilter template -->
<ng-template #dateFilter let-context let-params="$implicit.params">
  <ng-container *ngIf="context.state.dateOnly">
    <div class="flex flex--nowrap flex--row">
      <wfm-date-picker
        [autoWidth]="false"
        [disabled]="false"
        [format]="params.format"
        [placeholder]="params.placeholder"
        [hideOtherMonths]="true"
        [id]="context.columnId + '-$date'"
        [instructionalText]="params.instructionalText"
        [max]="params.maxDate"
        [min]="params.minDate"
        [rangeMode]="false"
        [(error)]="context.errors.input"
        [(value)]="context.state.value"
      >
      </wfm-date-picker>
    </div>
  </ng-container>
  <ng-container *ngIf="context.state.dateRangeOnly">
    <div class="flex flex--nowrap flex--row">
      <wfm-date-picker
        [autoWidth]="false"
        [disabled]="false"
        [endDateLabel]="params.endDateLabel || 'vg.endDate'"
        [format]="params.format"
        [placeholder]="params.placeholder"
        [hideOtherMonths]="true"
        [id]="context.columnId + '-$date-range'"
        [instructionalText]="params.instructionalText"
        [max]="params.maxDate"
        [min]="params.minDate"
        [rangeMode]="true"
        [startDateLabel]="params.startDateLabel || 'vg.startDate'"
        [(endError)]="context.errors.endInput"
        [(endValue)]="context.state.endValue"
        [(startError)]="context.errors.startInput"
        [(startValue)]="context.state.startValue"
      >
      </wfm-date-picker>
    </div>
  </ng-container>
  <ng-container *ngIf="!context.state.dateOnly && !context.state.dateRangeOnly">
    <div [id]="column.id + '-selection-wrapper'" class="scrollable" style="max-height: 378px" wfmScrollbar>
      <div [id]="column.id + '-$all-dates-wrapper'" class="radio-wrapper">
        <label [for]="column.id + '-$all-dates'" class="radio">
          <input
            [id]="column.id + '-$all-dates'"
            type="radio"
            name="radio_group"
            class="radio__input"
            [checked]="context.state.selectionId === '$all-dates'"
            (click)="context.setSelection('$all-dates')"
          />
          <span class="radio__label">{{ 'vg.allDates' | translate }}</span>
        </label>
      </div>
      <ng-container *ngIf="params.presets && params.presets.length">
        <ng-container *ngFor="let preset of params.presets">
          <div [id]="column.id + '-' + preset.id + '-wrapper'" class="radio-wrapper">
            <label [for]="column.id + '-' + preset.id" class="radio">
              <input
                [id]="column.id + '-' + preset.id"
                type="radio"
                name="radio_group"
                class="radio__input"
                [checked]="context.state.selectionId === preset.id"
                (click)="context.setSelection(preset.id)"
              />
              <span class="radio__label">{{ preset.label | translate }}</span>
            </label>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!context.dateOnly && params.showDate">
        <div [id]="column.id + '-$date-wrapper'" class="date-wrapper">
          <label [for]="column.id + '-$date'" class="radio">
            <input
              [id]="column.id + '-$date'"
              type="radio"
              name="radio_group"
              class="radio__input"
              [checked]="context.state.selectionId === '$date'"
              (click)="context.setSelection('$date')"
            />
            <span class="radio__label">{{ 'vg.date' | translate }}</span>
          </label>
          <div style="margin-left: 28px">
            <wfm-date-picker
              [autoWidth]="true"
              [compactMode]="cardFilterChild"
              [disabled]="context.state.selectionId !== '$date'"
              [format]="params.format"
              [placeholder]="params.placeholder"
              [hideOtherMonths]="true"
              [id]="context.columnId + '-$date'"
              [instructionalText]="params.instructionalText"
              [max]="params.maxDate"
              [min]="params.minDate"
              [rangeMode]="false"
              [(error)]="context.errors.input"
              [(value)]="context.state.value"
              (click)="context.setSelection('$date')"
            >
            </wfm-date-picker>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!context.dateRangeOnly && params.showDateRange">
        <div [id]="column.id + '-$date-range-wrapper'" class="date-wrapper">
          <label [for]="column.id + '-$date-range'" class="radio">
            <input
              [id]="column.id + '-$date-range'"
              type="radio"
              name="radio_group"
              class="radio__input"
              [checked]="context.state.selectionId === '$date-range'"
              (click)="context.setSelection('$date-range')"
            />
            <span class="radio__label">{{ 'vg.dateRange' | translate }}</span>
          </label>
          <div style="margin-left: 28px">
            <wfm-date-picker
              [autoWidth]="true"
              [compactMode]="cardFilterChild"
              [disabled]="context.state.selectionId !== '$date-range'"
              [endDateLabel]="params.endDateLabel || 'vg.endDate'"
              [format]="params.format"
              [placeholder]="params.placeholder"
              [hideOtherMonths]="true"
              [id]="context.columnId + '-$date-range'"
              [instructionalText]="params.instructionalText"
              [max]="params.maxDate"
              [min]="params.minDate"
              [rangeMode]="true"
              [startDateLabel]="params.startDateLabel || 'vg.startDate'"
              [(endError)]="context.errors.endInput"
              [(endValue)]="context.state.endValue"
              [(startError)]="context.errors.startInput"
              [(startValue)]="context.state.startValue"
              (click)="context.setSelection('$date-range')"
            >
            </wfm-date-picker>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<!-- SetFilter template -->
<ng-template #setFilter let-context let-params="$implicit.params">
  <ng-container *ngIf="params.showSearchInput">
    <div class="flex flex--nowrap flex--row flex--middle p-rel set-search-margin">
      <input
        class="textbox u-p--- input-with-icon"
        type="text"
        [id]="context.columnId + '-search-input'"
        [ngModel]="context.state.choiceFilter"
        [placeholder]="params.searchHint || ('vg.filterBy' | translate)"
        (ngModelChange)="context.onChoiceFilterChange($event)"
         />
      <div class="filter__icon filter__icon--no-event" *ngIf="!context.state.choiceFilter">
        <!-- ico-filter-16.svg -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          class="svg-icon eds-icon-color"
        >
          <g>
            <path
              d="M14.9.9l-4.65,7A1.55,1.55,0,0,0,10,8.7v6.8a.5.5,0,0,1-.72.45l-3-1.5A.51.51,0,0,1,6,14V8.71a1.56,1.56,0,0,0-.25-.84L1.1.9A.58.58,0,0,1,1.58,0H14.42A.58.58,0,0,1,14.9.9Z"
            />
          </g>
        </svg>
      </div>
      <div class="filter__icon" *ngIf="context.state.choiceFilter" (click)="context.removeSearch()">
        <!-- ico-close-12.svg -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          class="svg-icon eds-icon-color"
        >
          <g>
            <path
              d="M11.85,11.15a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0L6,6.71.85,11.85A.47.47,0,0,1,.5,12a.47.47,0,0,1-.35-.15.48.48,0,0,1,0-.7L5.29,6,.15.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0L6,5.29,11.15.15a.48.48,0,0,1,.7,0,.48.48,0,0,1,0,.7L6.71,6Z"
            />
          </g>
        </svg>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="context.state.choices.length">
    <div>
      <label
        [for]="context.columnId + '-select-all'"
        class="checkbox"
        [class.checkbox--disabled]="context.state.totalVisible === 0"
      >
        <input
          [id]="context.columnId + '-select-all'"
          type="checkbox"
          class="checkbox__input"
          [checked]="context.state.isAllChecked"
          [indeterminate]="context.state.isAllIndeterminate"
          (click)="context.onSelectAll()"
        />
        <span class="checkbox__label" [class.checkbox__indeterminate]="context.state.isAllIndeterminate">{{
          'vg.selectAll' | translate
        }}</span>
      </label>
    </div>
  </ng-container>

  <!-- <div class="scrollable" wfmScrollbar>
    <ng-container *ngFor="let choice of context.state.choices | setFilter : context.state.choiceFilter; let i = index">
        <div class="checkbox-wrapper">
          <label [for]="context.columnId + '-value-' + i" class="checkbox">
            <input [id]="context.columnId + '-value-' + i" type="checkbox" class="checkbox__input" (click)="context.onSelectChoice(choice)" [checked]="choice.isSelected">
            <span class="checkbox__label">{{ choice.item.label }}</span>
          </label>
        </div>
    </ng-container>
  </div> -->

  <!-- <div style="max-height: 298px" [style.height.px]="context.state.totalVisible * 34"> -->
  <cdk-virtual-scroll-viewport
    class="scrollable"
    style="max-height: 298px"
    [style.height.px]="context.state.totalVisible * 34"
    itemSize="34"
    minBufferPx="300"
    maxBufferPx="600"
    wfmScrollbar
  >
    <ng-container
      *cdkVirtualFor="let choice of context.state.choices | setFilter: context.state.choiceFilter; let i = index"
    >
      <div class="checkbox-wrapper">
        <label [for]="context.columnId + '-value-' + i" class="checkbox" [class.checkbox--disabled]="choice.item.disabled">
          <input
            [id]="context.columnId + '-value-' + i"
            type="checkbox"
            class="checkbox__input"
            (click)="context.onSelectChoice(choice)"
            [disabled]="choice.item.disabled"
            [checked]="choice.isSelected"
          />
          <span class="checkbox__label">{{ choice.item.label }}</span>
        </label>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
  <!-- </div> -->
</ng-template>

<!-- RangeFilter template -->
<ng-template #rangeFilter let-context let-params="$implicit.params">
  <div class="flex flex--nowrap flex--row flex--middle">
    <div class="range__fixed-width range__min-input">
      <!-- 
        By design, hitting 'Tab' will activate the next filter dropdown.  In this case, we want it to set focus
        to the max input.  So handle the keydown event on the tab and stop it from bubbling up.
      -->
      <input
        [id]="context.columnId + '-min-value'"
        type="number"
        class="textbox u-p---"
        [placeholder]="params.minHint || ('vg.min' | translate)"
        [(ngModel)]="context.data.minValue"
        (ngModelChange)="context.onModelChange()"
        [attr.aria-invalid]="context.errors.values"
        (keydown.tab)="$event.stopPropagation()"
      />
    </div>
    <div>
      <span class="text-16"> – </span>
    </div>
    <div class="range__fixed-width range__max-input">
      <!-- 
        By design, hitting 'Shift+Tab' will activate the previous filter dropdown.  In this case, we want it to
        set focus to the min input.  So handle the keydown event on the shift+tab and stop it from bubbling up.
      -->
      <input
        [id]="context.columnId + '-max-value'"
        type="number"
        class="textbox u-p---"
        [placeholder]="params.maxHint || ('vg.max' | translate)"
        [(ngModel)]="context.data.maxValue"
        (ngModelChange)="context.onModelChange()"
        [attr.aria-invalid]="context.errors.values"
        (keydown.shift.tab)="$event.stopPropagation()"
      />
    </div>
  </div>
  <ng-container *ngIf="params.units && params.units.length > 0">
    <div [id]="column.id + '-unit-wrapper'" class="scrollable u-mt--" wfmScrollbar>
      <ng-container *ngFor="let unit of params.units">
        <div [id]="context.columnId + '-' + unit.id + '-wrapper'" class="radio-wrapper">
          <label
            [for]="context.columnId + '-' + unit.id"
            class="radio"
            [class.radio--disabled]="!context.state.hasRange"
          >
            <input
              [id]="context.columnId + '-' + unit.id"
              type="radio"
              name="radio_group"
              class="radio__input"
              [checked]="context.data.unitId === unit.id"
              (click)="context.data.unitId = unit.id"
            />
            <span class="radio__label">{{ unit.label | translate }}</span>
          </label>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-template>
